import BaseApi from './baseApi';
import IRole from '../models/IRole';
import IAuthentication from '../models/IAuthentication';
import { EMPTY_GUID } from '../../config/constants';
export default class RoleApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Roles");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetRoles(idCompany: string) : Promise<IRole[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompany(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var roles: IRole[] = [];
            roles = response.data as IRole[];
            return roles;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveRole(role: IRole) : Promise<string> {
        const json = this.getJsonSave(role);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateRole(role: IRole) : Promise<boolean> {
        const json = this.getJsonUpdate(role);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteRole(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "Roles",
            "conditions": [{
                "Item1": "Roles",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(role: IRole) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "rolename",
                "Item2": role.roleName
            }, {
                "Item1": "idCompany",
                "Item2": role.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "Roles"
        };
        return json;
    }

    private getJsonUpdate(role: IRole) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "rolename",
                "Item2": role.roleName
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "Roles",
            "keyvalue": role.id
        };
        return json;
    }

    private getJsonReadWithIdCompany(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Roles",
                "Item2": "id"
            }, {
                "Item1": "Roles",
                "Item2": "roleName"
            }, {
                "Item1": "Roles",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "Roles"
            }],
            "conditions": [{
                "Item1": "Roles",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Roles",
                "Item2": "IdCompany",
                "Item3": "=",
                "Item4": idCompany
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "Roles",
                "Item2": "id"
            }, {
                "Item1": "Roles",
                "Item2": "roleName"
            }, {
                "Item1": "Roles",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "Roles"
            }],
            "conditions": [{
                "Item1": "Roles",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }]
        };
        return json;
    }
}
